import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { z } from 'zod'

import { authApi } from '@/api/auth'
import { Alert, AuthLayout, Button, Field } from '@/components/ui'
import { useApiError } from '@/features/auth/useApiError'

const schema = z.object({ email: z.string().email() })
type FormValues = z.infer<typeof schema>

export default function MagicLinkPage() {
  const { t } = useTranslation()
  const translateError = useApiError()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: zodResolver(schema) })

  const mutation = useMutation({ mutationFn: (v: FormValues) => authApi.requestMagicLink(v.email) })

  return (
    <AuthLayout
      title={t('auth.magicLink.title')}
      subtitle={t('auth.magicLink.subtitle')}
      footer={
        <Link to="/login" className="font-semibold text-brand-700 underline">
          {t('auth.magicLink.backToLogin')}
        </Link>
      }
    >
      {mutation.isSuccess ? (
        // Ουδέτερο μήνυμα: δεν αποκαλύπτεται αν η διεύθυνση αντιστοιχεί σε λογαριασμό.
        <Alert tone="success">{t('auth.magicLink.sent')}</Alert>
      ) : (
        <form
          className="flex flex-col gap-4"
          onSubmit={handleSubmit((values) => mutation.mutate(values))}
          noValidate
        >
          {mutation.isError && <Alert>{translateError(mutation.error)}</Alert>}

          <Field
            label={t('auth.fields.email')}
            type="email"
            autoComplete="email"
            inputMode="email"
            autoFocus
            error={errors.email && t('auth.validation.email')}
            {...register('email')}
          />

          <Button type="submit" loading={mutation.isPending}>
            {t('auth.magicLink.submit')}
          </Button>
        </form>
      )}
    </AuthLayout>
  )
}
